import { Fragment, useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import ButtonCommon from "../../components/ButtonCommon";
import CommonAccordian from "../../components/CommonAccordian";
import Header from "../../components/Header";
import CheckEligibiltyForm from "./Components/CheckEligibiltyForm";
import NavBar from "./navBar";
import './index.scss'
import ErrorSection from "./Components/ErrorSection";
import IsEligible from "./Components/IsEligible";
import AcceptOffer from "./Components/AcceptOffer";
import BureauVerification from "./Components/BureauVerification";
import NotEligible from "./Components/NotEligible";
import { getUserStatus } from '../../api/onboarding';
import { setToLocalStorage } from '../../utils/Helpers'
import CircularProgress from '@material-ui/core/CircularProgress';

const RegisterScreens = (props) => {
  const [showSection, setSection] = useState(1);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const fetchUserStatus = () => {
    setLoading(true);
    getUserStatus().then(async res => {
      setStatus(res)
      if (res.userState === 'OFFER_GENERATED') {
        setSection(2)
      }
      setLoading(false);
    })
  }

  useEffect(() => {
    fetchUserStatus();
  },[])

  const selctedTab = () => {
    if (loading) {
      return <Fragment>
        <div className="loading">
          <CircularProgress />
        </div>
      </Fragment>
    }
    if (showSection === 1) {
      return <CheckEligibiltyForm showSection={showSection} setSection={setSection} status={status} setStatus={setStatus} />
    } else if (showSection === 2) {
      return <AcceptOffer showSection={showSection} setSection={setSection} status={status} history={props.history} location={props.location} />
    }
  }

  return (
    <div className="pageWrapper">
      <Header props={props} />
      <div className="registerationContainer">
        <Col md={12}>
          <NavBar currentStep={showSection} />
        </Col>
        {selctedTab()}
      </div>
      <div className="poweredBy">
        <label>powered by</label>
        &nbsp;
        <img src="/RupifiLogo.png" alt="rupifyLogo" />
      </div>
    </div>
  )
}

export default RegisterScreens;